<div id="snapshot-item-{{ componentIndex }}" class="vtr-snapshot-list-item"
	[ngClass]="{'modified-module': component.info.IsDifferent}" >

	<mat-accordion class="vtr-material-expansion-panel">
		<mat-expansion-panel
			panelId="snapshot-item-{{ componentType }}-{{ componentIndex }}"
			[expanded]="detailsExpanded"
			[hideToggle]="component.status === snapshotStatus.noData"
			[disabled]="component.status === snapshotStatus.noData"
			(opened)="detailsExpanded = true"
			(closed)="detailsExpanded = false">
			<mat-expansion-panel-header-customize
				[ngClass]="{'border-bottom-theme': detailsExpanded}"
				[aria-label]="!detailsExpanded ? name + 'expand-module-details': name + 'collapse-module-details'">
				<div class="module-information" [ngClass]="{ 'last-child': isLastElement }">
					<div class="module-icon">
						<!-- Defines an icon according with component -->
						<img id="snapshot-item-{{ componentIndex }}-icon" *ngIf="getModuleIcon(name) !== ''"
							alt="{{ name }}"
							class="img-icon"
							[ngClass]="{'img-icon-disabled':getModuleIcon(name).indexOf('disabled')!==-1}"
							role="img"
							[src]="getModuleIcon(name) | svgInline | async" />
					</div>

					<!-- Icon to expand and collapse module information -->
					<div class="row" [ngClass]="{ 'component-disabled': component.status === snapshotStatus.noData }">
						<p id="snapshot-item-{{ componentIndex }}-module" role="text" class="title mb-0"
								*ngIf="!component.info.IsDifferent; else modifiedTitle">
							{{ 'snapshot.components.' + name | translate }}</p>

						<ng-template #modifiedTitle>
							<p id="snapshot-item-{{ componentIndex }}-module" role="text" class="title modified-item mb-0">
								* {{ 'snapshot.components.' + name | translate }}</p>
						</ng-template>
					</div>

					<!-- Shows load icon until modules are not loaded -->
					<img *ngIf="component.status !== snapshotStatus.hasData &&
								component.status !== snapshotStatus.noData; else updateButton"
						role="img" class="load-icon" [src]="'assets/icons/snapshot/icon_snapshot_progress.svg' | svgInline | async"/>

					<!-- Shows button to update after modules get loaded -->
					<ng-template #updateButton>
						<vtr-ui-hyperlink-button
							class="hyperlink-container update-btn"
							[ngClass]="{ 'update-btn-without-expand': component.status === snapshotStatus.noData }"
							linkId="snapshot-{{ componentType }}-{{ componentIndex }}-update-btn"
							hyperlinkStyle="xs-white"
							[label]=" ('snapshot.snapshotUpdateButton' | translate).toUpperCase() "
							[isDisabled]="!isUpdateEnabled()"
							(hyperlinkClick)="updateSnapshot()"
							[tooltipText]="'snapshot.startComponentSnapshot' | translate: {'component':('snapshot.components.'+ name) | translate}">
						</vtr-ui-hyperlink-button>
					</ng-template>
					<ng-template #hideDetailsInfo>
						<div class="hide-details-info"></div>
					</ng-template>
				</div>
			</mat-expansion-panel-header-customize>
			<div class="details-list">
				<table id="snapshot-item-{{ componentIndex }}-details" class="table table-details table-borderless">
					<tbody>
						<tr *ngIf="component.status !== snapshotStatus.hasData; else moduleInfo">
							<td class="progress-warning-image">
								<fa-icon [icon]="['fal', 'circle-notch']" [spin]="true"></fa-icon>
							</td>
						</tr>
						<ng-template #moduleInfo>
							<tr>
								<td aria-hidden="true"></td>
								<th id="snapshot-item-{{ componentIndex }}-detail-baseline-snapshot-title" class="snapshot-table-titles">
									{{ 'snapshot.baselineSnapshot' | translate }}
								</th>
								<th id="snapshot-item-{{ componentIndex }}-detail-baseline-snapshot-title" class="snapshot-table-titles">
									{{ 'snapshot.lastSnapshot' | translate }}
								</th>
							</tr>

							<tr>
								<th id="snapshot-item-{{ componentIndex }}-detail-updated-date" class="table-info-name">
									{{ 'snapshot.properties.UpdatedDate' | translate }}
								</th>
								<td id="snapshot-item-{{ componentIndex }}-detail-update-date-base-value">
									<!-- Adding UTC string to ensure the correct date/time format -->
									{{ component.info.BaselineDate + ' UTC' | formatLocaleDateTime }}</td>
								<td id="snapshot-item-{{ componentIndex }}-detail-update-date-current-value">
									<!-- Adding UTC string to ensure the correct date/time format -->
									{{ component.info.LastSnapshotDate + ' UTC'| formatLocaleDateTime }}</td>
							</tr>

							<ng-template #recursiveList let-list>
								<ng-container *ngFor="let values of list; let i = index; let last = last;">
									<tr *ngFor="let property of values.Properties; let j = index">
										<th id="snapshot-item-{{ i }}-detail-{{ j }}-property-name" class="table-info-name">
											{{ 'snapshot.properties.' + property.PropertyName | translateDefault:property.PropertyName }}
										</th>
										<td id="snapshot-item-{{ i }}-detail-{{ j }}-base-value">
											{{ property.BaseValue | formatIfDateTimeOrTranslateDefault:property.BaseValue:'snapshot.propertyValue.' }}</td>

										<td id="snapshot-item-{{ i }}-detail-{{ j }}-current-value" [ngClass]="{'modified-item': property.IsDifferent}">
											{{ property.CurrentValue | formatIfDateTimeOrTranslateDefault:property.CurrentValue:'snapshot.propertyValue.' }}</td>
									</tr>
									<ng-container *ngIf="array.isArray(values.SubDevices) && values.SubDevices.length > 0">
										<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: values.SubDevices }"></ng-container>
									</ng-container>
									<tr *ngIf="!last" class="table-info-separator" aria-hidden="true"></tr>
								</ng-container>
							</ng-template>
							<ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: component.info.Items }"></ng-container>
						</ng-template>
						<tr class="table-info-separator" aria-hidden="true"></tr>
					</tbody>
				</table>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>
